module.exports = __webpack_public_path__ + "static/map_horizontal_eur-e5569c273778ad6d136298d26436e97e.png";